import DefaultCRUD from '../utils'

const resource = `/user/permission/object`;

const { get, create, update, remove } = DefaultCRUD(resource)

export default {
  get,
  create,
  update,
  delete:remove,
}
